import { UseMutationResult } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import api from 'core/services/fetch-api/useApi';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import { userDetailResponse } from 'core/types/models/userInfo';
import { useDispatch } from 'react-redux';
import toastHandler from 'core/helpers/toast/toast';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';

export const updateUserInfoQuery = (callback?: () => void) => {
	const dispatch = useDispatch();

	return useMutationHook(
		[endPointUrls.ADMIN_USERS()],
		(data: any) => api.patch(endPointUrls.ADMIN_USERS(), data),
		{
			onSuccess: (res: any) => {
				if (res?.status === 200) {
					callback?.();
					toastHandler('success', res?.data.message);
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult<userDetailResponse, Error>;
};
